import script from "./FilterLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterLabel.vue?vue&type=script&setup=true&lang=ts"

import "./FilterLabel.vue?vue&type=style&index=0&id=c3bea920&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3bea920"]])

export default __exports__